import React, { useEffect, useState } from "react";
import DeviceModelsTable from "./components/DeviceModelsTable";
import Edit from "./modals/Edit";
import Delete from "./modals/Remove";
import Create from "./modals/Create";
import Divider from "@material-ui/core/Divider/index";
import axios from "axios";
import { useSelector } from "react-redux";
function DeviceModels(props) {
  const token = useSelector((state) => state.auth.token);
  const [deviceModels, setDeviceModels] = useState([]);
  const [chooseDeviceModelId, setChooseDeviceModelId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteDeviceModelsIds, setDeleteDeviceModelsIds] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");




  const onDeviceModels = (orderBy, sortField, skip, take) => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}deviceModel?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}`, {
        headers: { Authorization: `bearer ${token}` },
      })
      .then(({ data: { content ,totalElements} }) => {
        setIsLoading(false);
        setDeviceModels(content);
        setIsError(false);
        setCount(totalElements)

      })
      .catch(() => {
        setIsLoading(false);
        setDeviceModels([]);
        setIsError(true);
      });
  };

  const onDeviceModelChoose = (id) => {
    return axios.get(`${process.env.REACT_APP_API_URL}deviceModel/${id}`, {
      headers: { Authorization: `bearer ${token}` },
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onDeviceModels(orderBy, sortField, skip, take);
    }, 500);
    return () => clearTimeout(timer);
  }, [orderBy, sortField, skip, take]);


  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Qurğu modeli</h1>
       
      </div>
      <Divider className="w-100" />
      <DeviceModelsTable
        deviceModels={deviceModels}
        isLoading={isLoading}
        isError={isError}
        setChooseDeviceModelId={setChooseDeviceModelId}
        setShowCreate={setShowCreate}
        setShowRemove={setShowRemove}
        setShowEdit={setShowEdit}
        setDeleteDeviceModelsIds={setDeleteDeviceModelsIds}
        deleteDeviceModelsIds={deleteDeviceModelsIds}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        count={count}
        updateSkip={setSkip}
        updateTake={setTake}
       
      />
      {showCreate && (
        <Create
          show={showCreate}
          onHide={setShowCreate}
          onDeviceModels={onDeviceModels}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
        />
      )}

   

      {showRemove && (
        <Delete
          id={chooseDeviceModelId}
          show={showRemove}
          onHide={setShowRemove}
          onDeviceModels={onDeviceModels}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
        />
      )}


      {showEdit && (
        <Edit
          show={showEdit}
          onHide={setShowEdit}
          onDeviceModels={onDeviceModels}
          id={chooseDeviceModelId}
          onDeviceModelChoose={onDeviceModelChoose}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
        />
      )}


     
    </div>
  );
}

export default DeviceModels;
